module.exports = __webpack_public_path__ + "img/solution-background.d6e669fa.png";